export const CONTACT_CREATE_RESET = 'CONTACT_CREATE_RESET'
export const CONTACT_CREATE_SET_CREATED = 'CONTACT_CREATE_SET_CREATED'
export const CONTACT_CREATE_SET_ERROR = 'CONTACT_CREATE_SET_ERROR'
export const CONTACT_CREATE_SET_VIOLATIONS = 'CONTACT_CREATE_SET_VIOLATIONS'
export const CONTACT_CREATE_TOGGLE_LOADING = 'CONTACT_CREATE_TOGGLE_LOADING'
